<template>
  <div
    class="tab-container"
    :class="{ active: isActive }"
    @click="$emit('selected')"
  >
    <div class="tab-container__tab tab">
      <div class="tab__item tab__name">
        <!-- Tab text -->
        <slot />
      </div>
      <div v-if="hasRemoveIcon" class="tab__item tab__delete">
        <delete
          class="media-tab-icon media-tab-icon_action_delete"
          title="Delete All"
          @click="deleteAll"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Delete from "vue-material-design-icons/Delete.vue";

// @group Media
// Select media tab
export default {
  name: "MediaTab",
  components: {
    Delete
  },
  props: {
    /** Is tab selected */
    isActive: {
      type: Boolean,
      default: false
    },
    /** Is tab has remove icon */
    hasRemoveIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // @vuese
    // Remove all media (or tab)
    deleteAll(e) {
      this.$emit("deleteAll");
      e.stopPropagation();
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-container {
  border: none;
  background-color: var(--dark-grey);

  &__tab {
    height: 100%;
  }
}
.tab-container:not(.active) .tab:hover {
  color: #409eff;
}
.tab-container.active .tab {
  background-color: #aaaaaa;
}
.tab-container.active:last-child .tab {
  border-top-right-radius: 0;
}
.tab-container.active:first-child .tab {
  border-top-left-radius: 0;
}
.tab-container:not(.active) {
  cursor: pointer;
}
.tab {
  padding: 10px 0;
  display: flex;
  justify-content: center;

  &__name {
    flex-grow: 1;
  }

  &__delete {
    margin-right: 1em;
  }
}
</style>

<style lang="scss">
.media-tab-icon {
  &_action {
    &_delete {
      .material-design-icon__svg {
        &:hover {
          color: #d76969;
        }
      }
    }
  }

  .material-design-icon__svg {
    width: 1rem !important;
    height: 1rem !important;
  }
}
</style>
